import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import {E, A} from './util.mjs'
import * as u from './util.mjs'
import * as eff from './elem-form-field.mjs'

export function RadioGroup({class: cls}, ...chi) {
  return (
    a.vac(chi) &&
    E(`div`, {role: `radiogroup`, class: u.cls(`radio-buttons`, cls)}, chi)
  )
}

export function RadioPairs(ctx, src) {
  return a.map(src, a.bind(RadioPair, ctx))
}

function RadioPair(ctx, {value, title, id, class: cls, ...rest}) {
  id ||= ctx.seq.nextId()

  return [
    E(`input`, A.with(rest).type(`radio`).id(id).value(value).cls(`invis`)),
    E(`label`, A.for(id).cls(`radio-label`).cls(cls), title || value),
  ]
}

/*
Intended for a radio group followed by a text field.
Counterpart to React component `FormFieldTextWithRadio`.

When rendering this element, the caller must provide at least the following
children or descendants: one regular input (text or numeric), and `RadioPairs`.

TODO UX enhancement: on any change coming from the text input, store the
typed-in value by updating the value and title of the last radio selectable.
The value in the input, and the title in the corresponding label. Tricky to
implement generically, because it requires us to know how to render the title
from the value.
*/
export class FormFieldTextWithRadio extends eff.FormField {
  static {dr.reg(this)}

  connectedCallback() {this.onchange = this.onChange}
  radios() {return a.filter(this.elements, u.isRadioInput)}
  nonRadio() {return a.find(this.elements, u.isNonRadioInput)}

  onChange(eve) {
    a.eventKill(eve)

    if (eve.target.type === `radio`) {
      this.nonRadio().replaceAll(eve.target.value)
      return
    }

    for (const val of this.radios()) {
      val.checked = val.value === eve.target.value
    }
  }
}
